import { render, staticRenderFns } from "./Send.vue?vue&type=template&id=1d58a22a&scoped=true"
import script from "./Send.vue?vue&type=script&lang=js"
export * from "./Send.vue?vue&type=script&lang=js"
import style0 from "./Send.vue?vue&type=style&index=0&id=1d58a22a&lang=scss&scoped=true"
import style1 from "./Send.vue?vue&type=style&index=1&id=1d58a22a&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d58a22a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/erp-flexible-web21_zo1Z/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d58a22a')) {
      api.createRecord('1d58a22a', component.options)
    } else {
      api.reload('1d58a22a', component.options)
    }
    module.hot.accept("./Send.vue?vue&type=template&id=1d58a22a&scoped=true", function () {
      api.rerender('1d58a22a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Email/Send.vue"
export default component.exports